import React, { useEffect } from 'react';

// Ageless.ai "See Your Results" transformation embed.
const AGELESS_URL =
  'https://www.ageless.ai/embed/platforms/4351b7e8-50ee-41ec-a606-fcd1bf71456c/a/lifeandwellnesscenter/transformation?utm_source=website_embed&utm_medium=embed';
const LOADER_SRC = 'https://www.ageless.ai/embed/v1/loader.js';

const AgelessEmbed = () => {
  useEffect(() => {
    // Load the Ageless loader script once (it upgrades the custom element).
    if (!document.querySelector(`script[src="${LOADER_SRC}"]`)) {
      const script = document.createElement('script');
      script.src = LOADER_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <ageless-embed-launcher
      data-ageless-url={AGELESS_URL}
      data-ageless-mode="inline"
      data-ageless-label="See Your Results"
      data-ageless-color="#3F6A55"
      data-ageless-radius="pill"
      data-ageless-shadow="elevated"
    />
  );
};

export default AgelessEmbed;
